import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class UpdateFaq extends Component {
  state = {
    id: "",
    question: "",
    answer: "",

    message: "",
    notification: false,
    notiColor: "success",
    loading: false,
    redirect: false,
  };

  componentDidMount() {
    this.getSingleFaq();
  }

  // ✅ FETCH SINGLE FAQ
  getSingleFaq = async () => {
    const id = window.location.pathname.split("/")[2];

    try {
      if (init() == "success") {
        const resp = await axios.post(Constants.getUrls.getFaqDetails, { id });

        if (resp.data.status) {
          const data = resp.data.data;

          this.setState({
            id,
            question: data.question || "",
            answer: data.answer || "",
          });
        }
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Failed to fetch FAQ",
        notiColor: "warning",
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // ✅ UPDATE FAQ
  handleSubmit = async (e) => {
    e.preventDefault();

    const { id, question, answer } = this.state;

    if (!question || !answer) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      id,
      question,
      answer,
      role_id: 1, // ✅ fixed
    };

    this.setState({ loading: true });

    try {
      if (init() == "success") {
        const resp = await axios.post(Constants.putUrls.updateFaq, payload);

        this.setState({
          notification: true,
          message: resp.data.message || "FAQ updated successfully!",
          notiColor: "success",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 1500);
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/faqs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>
            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update FAQ
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>
                {/* QUESTION */}
                <Grid item sm={12}>
                  <TextField
                    label="Question"
                    name="question"
                    value={this.state.question}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* ANSWER */}
                <Grid item sm={12}>
                  <TextField
                    label="Answer"
                    name="answer"
                    value={this.state.answer}
                    onChange={this.handleInput}
                    multiline
                    rows={4}
                    fullWidth
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>
              </Grid>
            </form>
          </Card>

          <MDSnackbar
            color={this.state.notiColor}
            title="FAQ"
            content={this.state.message}
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
